import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import iso from '../../../assets/images/iso.png';
import logo from '../../../assets/images/logo.png';
import './footer.css';


class Footer extends Component {
    render() {
        return (
            <React.Fragment>
                <footer>
                    <div className='container-footer'>
                        <div className='row'>
                            <div className='col-sm-12 col-md-4'>
                                <img src={logo} alt='nalsoft-logo' />
                                <div id='info-content'>
                                    <p>
                                        〒450-0002<br />愛知県名古屋市中村区名駅3丁目11番22号 <br /> ＩＴ名駅ビル7階<br />
                                        <span>TEL: 052-433-7796 / FAX：052-433-7686</span>
                                    </p>
                                    <ul className='info-link'>
                                        <li><a href='/privacy-policy#privacy'>個人情報保護方針</a></li>
                                        <li><a href='/privacy-policy#security'>情報セキュリティ基本方針</a></li>
                                    </ul>
                                </div>
                            </div>

                            <div className='col-xs-6 col-md-2'>
                                <ul className='footer-links'>
                                    <li><h6>QUICK LINKS</h6></li>
                                    <li><Link to='/'>HOME</Link></li>
                                    <li><Link to='/news'>NEWS</Link></li>
                                    <li><Link to='/company'>COMPANY</Link></li>
                                    <li><Link to='/people'>OUR TEAM</Link></li>
                                </ul>
                            </div>

                            <div className='col-xs-6 col-md-2'>
                                <ul className='footer-links'>
                                    <li><h6>SERVICE</h6></li>
                                    <li><a href='/service#system-container' >システム開発</a></li>
                                    <li><a href='/service#package-container' >パッケージ開発・導入</a></li>
                                    <li><a href='/service#tech-container' >技術支援</a></li>
                                    <li><a href='/service#infra-container' >インフラ構築</a></li>
                                </ul>
                            </div>

                            <div className='col-xs-6 col-md-2'>
                                <ul className='footer-links'>
                                    <li><h6>RECRUIT</h6></li>
                                    <li><Link to='/recruit/headquarter' >新卒採用【本社】</Link></li>
                                    <li><Link to='/recruit/tokyo' >新卒採用【東京】</Link></li>
                                    <li><Link to='/recruit/mid-level-engineer' >中途採用／システムエンジニア</Link></li>
                                    <li><Link to='/recruit/mid-level-programmer' >中途採用／プログラマー</Link></li>
                                </ul>

                            </div>

                            <div className='col-xs-6 col-md-2'>
                                <img src={iso} alt='nalsoft-iso' />
                            </div>
                        </div>
                    </div>

                    <hr />

                    <div className='container'>
                        <div className='row'>
                            <div className='col-12'>
                                <p id='copyright-text'>© NAL Software Co., Ltd. All Rights Reserved.</p>
                            </div>
                        </div>
                    </div>
                </footer>
            </React.Fragment>
        )
    }
}

export default Footer;